<template>
  <div class="return-details fade-in">
    <ProductDetailsHeader
        title="Supplier Return Details"
        icon="arrow-return-left"
        :main="supplierReturn"
        :header-details="headerDetails"
    >
      <template #header-actions>
        <div class="d-flex flex-wrap align-items-center gap-2">
          <select
              v-if="supplierReturn.status !== 'complete' && returnProducts.data.length > 0"
              class="form-select w-auto"
              v-model="returnStatus"
              @change="confirmDialog(getConfirmTitle, updateReturnStatus, 'Are you sure you want to approve this supplier return?')" data="">
            <option value="" disabled selected>Change Status</option>
            <option v-if="supplierReturn.status === 'pending'" value="complete" class="text-success fs-5">Approve Return</option>
          </select>
        </div>
      </template>
    </ProductDetailsHeader>

    <StoreProducts
        v-if="supplierReturn.status === 'pending'"
        :per-page="5"
        :marked-products="returnProducts.data"
        @row-click="populateAddProduct"
    />

    <ProductDetailsPages
        title="Supplier Return"
        :loading="loading"
        :detail-products="returnProducts"
        :current-page="detailsPage"
        :current-per-page="detailsPerPage"
        :current-search="detailsSearch"
        @update:page="onDetailsPageChange"
        @update:per-page="onDetailsPerPageChange"
        @update:search="onDetailsSearchChange"
        :main="supplierReturn"
        @edit-product="populateReturnEdit"
        @delete-product="deleteReturnProduct"
    >
      <template #footer-actions>
        <select
            v-if="supplierReturn.status !== 'complete' && returnProducts.data.length > 0"
            class="form-select w-auto"
            v-model="returnStatus"
            @change="confirmDialog(getConfirmTitle, updateReturnStatus, 'Are you sure you want to approve this supplier return?')" data="">
          <option value="" disabled selected>Change Status</option>
          <option v-if="supplierReturn.status === 'pending'" value="complete" class="text-success fs-5">Approve Return</option>
        </select>
      </template>
    </ProductDetailsPages>

    <Modal :open="addProductModal" @closed="addProductModal = false" dialog-size="modal-lg">
      <div class="modal-header">
        <h5 class="modal-title m-0" v-if="addProductMode === 'add'">
          <i class="bi bi-plus-circle me-2 text-primary"></i>Add Product to Return
        </h5>
        <h5 class="modal-title m-0" v-else>
          <i class="bi bi-pencil-square me-2 text-primary"></i>Edit Return Product
        </h5>
        <button @click="addProductModal = false" type="button" class="btn-close outline-none" data-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="">
          <div class="row">
            <div class="form-group col-md-12">
              <label for="name" class="form-label fw-medium mb-2">Product Name:</label>
              <input type="text" class="form-control" :value="selectedProduct.name" disabled>
            </div>
            <div class="form-group col-md-6 mt-3">
              <label for="quantity" class="form-label fw-medium mb-2">Quantity:</label>
              <div class="input-group">
                <input type="number" class="form-control" autofocus="autofocus" v-model="returnDetails.quantity" min="1" required>
                <span class="input-group-text" v-if="selectedProduct.unit">{{ selectedProduct.unit.name }}</span>
              </div>
              <small class="form-text text-muted">Available stock: {{ selectedProduct.stock || 0 }}</small>
            </div>
            <div class="form-group col-md-6 mt-3">
              <label for="price" class="form-label fw-medium mb-2">Return Price: <span class="text-muted fst-italic small">(optional)</span></label>
              <div class="input-group">
                <span class="input-group-text">$</span>
                <input type="number" class="form-control" v-model="returnDetails.price" min="0" step="0.01">
              </div>
            </div>
            <div class="form-group col-md-12 mt-3">
              <label for="reason" class="form-label fw-medium mb-2">Reason for Return: <span class="text-muted fst-italic small">(optional)</span></label>
              <textarea class="form-control" v-model="returnDetails.reason" placeholder="Enter reason for return" rows="3"></textarea>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="addProductModal = false">Cancel</button>
        <button type="button" class="btn btn-primary" v-if="addProductMode === 'add'" @click="addReturnProduct">
          <i class="bi bi-plus-lg me-1"></i> Add Product
        </button>
        <button type="button" class="btn btn-primary" v-else @click="updateReturnProduct(returnDetails.id)">
          <i class="bi bi-check-lg me-1"></i> Update Product
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import supplierReturnService from "@/api/supplierReturnService";
import confirmDialog  from "@/utils/confirmDialog";
import notify from "@/utils/notify";
import ProductDetailsHeader from "@/components/details/ProductDetailsHeader.vue";
import ProductDetailsPages from "@/components/details/ProductDetailsPages.vue";
import StoreProducts from "@/components/store/StoreProducts.vue";

export default {
  name: "SupplierReturnDetails",

  components: { ProductDetailsHeader, ProductDetailsPages, StoreProducts },

  data(){
    return {
      profile: {},
      returnStatus: '',
      supplierReturn: {
        store: {},
        supplier: {},
        user: {},
      },
      returnDetails: {
        supplier_return_id: this.$route.params.id,
        product_id: '',
        quantity: 1,
        price: '',
        reason: '',
      },
      selectedProduct: {},
      returnProducts: { data: [] },
      detailsPage: 1,
      detailsPerPage: 20,
      detailsSearch: '',
      loading: true,
      addProductModal: false,
      addProductMode: 'add',
    }
  },

  methods:{
    confirmDialog,
    async updateReturnStatus() {
      let response = await supplierReturnService.approveSupplierReturn(this.$route.params.id)
      if (response) {
        window.location.reload()
      }
    },
    async getReturnDetails() {
      this.returnProducts = await supplierReturnService.getSupplierReturnDetails(this.$route.params.id, {
        page: this.detailsPage,
        per_page: this.detailsPerPage
      })
      this.loading = false
    },
    onDetailsPageChange(page){
      this.detailsPage = page;
      this.getReturnDetails();
    },
    onDetailsPerPageChange(perPage){
      this.detailsPerPage = perPage;
      this.detailsPage = 1;
      this.getReturnDetails();
    },
    onDetailsSearchChange(search){
      this.detailsSearch = search;
      this.detailsPage = 1;
      this.getReturnDetails();
    },
    populateAddProduct(storeProduct) {
      this.addProductModal = true;
      this.addProductMode = 'add';
      this.selectedProduct.name = storeProduct.product.name;
      this.selectedProduct.stock = storeProduct.stock;
      this.selectedProduct.unit = storeProduct.product.unit;
      this.returnDetails.product_id = storeProduct.product_id;
      this.returnDetails.quantity = 1;
      this.returnDetails.price = storeProduct.price;
    },
    async addReturnProduct() {
      if (this.returnDetails.quantity > (this.selectedProduct.stock || 0)) {
        notify.alert.error('Insufficient stock quantity', 3000);
        return;
      }
      let response = await supplierReturnService.createSupplierReturnDetails(this.returnDetails);
      if (response) {
        this.addProductModal = false;
        await this.getReturnDetails();
      }
    },
    async updateReturnProduct() {
      let response = await supplierReturnService.updateSupplierReturnDetails(this.returnDetails, this.returnDetails.id);
      if (response) {
        this.addProductModal = false;
        await this.getReturnDetails();
      }
    },
    populateReturnEdit(returnItem) {
      this.selectedProduct.name = returnItem.product.name;
      this.selectedProduct.stock = returnItem.product.stock;
      this.selectedProduct.unit = returnItem.product.unit;
      this.returnDetails.product_id = returnItem.product_id;
      this.returnDetails.id = returnItem.id;
      this.returnDetails.quantity = returnItem.quantity;
      this.returnDetails.price = returnItem.price;
      this.returnDetails.reason = returnItem.reason;
      this.addProductModal = true;
      this.addProductMode = 'edit';
    },
    async deleteReturnProduct(id) {
      let response = await supplierReturnService.deleteSupplierReturnDetails(id)
      if (response) {
        await this.getReturnDetails()
      }
    },
  },

  computed: {
    headerDetails() {
      return [
        { icon: 'shop', label: 'Store', key: 'store.name' },
        { icon: 'truck', label: 'Supplier', key: 'supplier.name' },
        { icon: 'person', label: 'By', key: 'user.first_name' },
      ];
    },
    getConfirmTitle() {
      switch (this.returnStatus) {
        case 'complete':
          return 'Approve Supplier Return'
        default:
          return 'Update Return Status'
      }
    }
  },

  created: async function () {
    this.supplierReturn = await supplierReturnService.getSupplierReturn(this.$route.params.id)
    await this.getReturnDetails()
  },

  watch: {
    addProductModal: function () {
      if (!this.addProductModal) {
        this.selectedProduct = {}
        this.returnDetails = {
          supplier_return_id: this.$route.params.id,
          product_id: '',
          quantity: 1,
          price: '',
          reason: '',
        }
      }
    }
  },

}
</script>

<style scoped>
</style>
